import { render, staticRenderFns } from "./works-programme.vue?vue&type=template&id=5572dad4&"
import script from "./works-programme.vue?vue&type=script&lang=js&"
export * from "./works-programme.vue?vue&type=script&lang=js&"
import style0 from "./works-programme.vue?vue&type=style&index=0&id=5572dad4&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports